import { action } from 'nanostores'
import { $campaigns, $currentCampaignList, $promises } from './stores'
import type { Campaign } from '@/models/campaign'
import type { Campaign as PopsCampaign } from '@/types/pops'

export const setCampaign = action(
  $campaigns,
  'setCampaign',
  (
    store,
    { campaignId, campaign }: { campaignId: number; campaign: Campaign },
  ) => {
    store.setKey(campaignId.toString(), campaign)
  },
)

export const setCurrentCampaignList = action(
  $currentCampaignList,
  'setCurrentCampaignList',
  (store, { currentCampaigns }: { currentCampaigns: PopsCampaign[] }) => {
    store.set(currentCampaigns)
  },
)

export const setPromise = action(
  $promises,
  'setPromise',
  (store, { promiseKey, promise }) => {
    store.setKey(promiseKey, promise)
  },
)
export const clearPromises = action($promises, 'clearPromises', (store) => {
  store.set({})
})
